'use client'
import { Button } from '@/components/Button'
import { Icon } from '@/icons'
import { RecommendedService } from '@/services/Api/generated'
import cn from 'classnames'
import Link from 'next/link'
import { FC, useCallback, useRef, useState } from 'react'
import 'swiper/css'
import 'swiper/css/free-mode'
import { FreeMode } from 'swiper/modules'
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react'
import styles from './Services.module.scss'

interface ServicesProps {
  className?: string
  services: RecommendedService[]
}
export const Services: FC<ServicesProps> = ({ className, services }) => {
  const swiperRef = useRef<SwiperRef>(null)

  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  const updateButtonsState = useCallback(() => {
    if (swiperRef.current) {
      const swiper = swiperRef.current.swiper
      setIsBeginning(swiper.isBeginning)
      setIsEnd(swiper.isEnd)
    }
  }, [])

  const next = useCallback(() => {
    swiperRef.current?.swiper.slideNext()
  }, [])

  const prev = useCallback(() => {
    swiperRef.current?.swiper.slidePrev()
  }, [])

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.title}>Дополнительные услуги</div>
      <div className={styles.sliderContainer}>
        <Swiper
          className={styles.swiperContainer}
          ref={swiperRef}
          spaceBetween={24}
          wrapperClass={styles.swiperWrapper}
          slidesPerView={'auto'}
          modules={[FreeMode]}
          freeMode={true}
          breakpoints={{
            320: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          onSlideChange={updateButtonsState}
          onSwiper={updateButtonsState}
          onResize={updateButtonsState}
        >
          {services.map((service, index) => (
            <SwiperSlide key={index} className={styles.item}>
              <Link href={'/uslugi' + service.url} className={styles.service}>
                <div className={styles.serviceTitle}>{service.title}</div>
                {service.price != null ? (
                  <div className={styles.servicePrice}>
                    от {new Intl.NumberFormat('ru-RU').format(service.price)} ₽
                  </div>
                ) : null}
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
        <Button
          variant="opacity"
          className={cn(styles.button, styles.prev, {
            [styles.hideOnMd]: services.length <= 3,
            [styles.hideOnSm]: services.length <= 2,
            [styles.hideOnXs]: services.length <= 1,
          })}
          onClick={prev}
          disabled={isBeginning}
          ariaLabel="Назад"
        >
          <Icon name="arrow" className={styles.iconPrev} />
        </Button>
        <Button
          variant="opacity"
          className={cn(styles.button, styles.next, {
            [styles.hideOnMd]: services.length <= 3,
            [styles.hideOnSm]: services.length <= 2,
            [styles.hideOnXs]: services.length <= 1,
          })}
          onClick={next}
          disabled={isEnd}
          ariaLabel="Вперед"
        >
          <Icon name="arrow" className={styles.iconNext} />
        </Button>
      </div>
    </div>
  )
}
